import { LegacyActivities } from './LegacyActivities';
import { ModernActivities } from './ModernActivities';
import { PurchaseOrder } from '../../../Lib/Types/purchase-order';
import { Vendor } from '../../../Lib/Api/vendor';
import Roles, { RolesType } from '../../../Lib/Constants/roles';

export type PurchaseOrderActivitiesProps = {
  purchaseOrder: PurchaseOrder;
  userId: string;
  vendor: Vendor;
  userRole?: RolesType;
};

export function PurchaseOrderActivities(props: PurchaseOrderActivitiesProps) {
  const { purchaseOrder, userId, vendor, userRole } = props;

  if (userRole === Roles.VENDOR_OPERATIONS) {
    return null;
  }

  if (purchaseOrder.purchase_order_activities?.length) {
    return (
      <ModernActivities
        purchaseOrder={purchaseOrder}
        userId={userId}
        vendor={vendor}
      />
    );
  }

  return (
    <LegacyActivities
      purchaseOrder={purchaseOrder}
      userId={userId}
      vendor={vendor}
    />
  );
}
